<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="foreword">
<h1></h1>
<p>The Moving Finger writes and having writ moves on Nor all thy piety nor wit can move it back to cancel half a line. Nor all thy tears wash out a word of it.</p><br/>
<p style="text-align: right;"><strong>From the Rubayat of Omar Khyam</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?453e273a